var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTiktokFooter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#75777B",
    fillRule: "evenodd",
    d: "M19.543 2.4H4.457A2.057 2.057 0 0 0 2.4 4.457v15.086A2.057 2.057 0 0 0 4.457 21.6h15.086a2.057 2.057 0 0 0 2.057-2.057V4.457A2.057 2.057 0 0 0 19.543 2.4m-4.126 7.001a6.52 6.52 0 0 0 3.783 1.196V7.934a3.77 3.77 0 0 1-2.064-.613 3.75 3.75 0 0 1-1.086-1.054 3.7 3.7 0 0 1-.576-1.391c-.04-.223-.059-.45-.057-.676h-2.711v10.648c0 .48-.154.946-.438 1.335a2.298 2.298 0 0 1-1.146.826c-.46.15-.957.15-1.418.004a2.298 2.298 0 0 1-1.151-.82 2.258 2.258 0 0 1-.016-2.669c.282-.39.681-.681 1.14-.833.46-.152.957-.156 1.42-.012v-2.74a5.057 5.057 0 0 0-2.95.487 4.984 4.984 0 0 0-2.143 2.062 4.908 4.908 0 0 0 .627 5.611 5.02 5.02 0 0 0 2.547 1.55c.989.247 2.03.19 2.985-.163a5 5 0 0 0 2.36-1.816 4.917 4.917 0 0 0 .894-2.822V9.4Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTiktokFooter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tiktok-footer.c24c222525c146537820e2e6cd900221.svg";